import type { DashboardApprovalDocumentItem } from "@models";
import type { ReactNode } from "react";
import { DashboardConnectedCard } from "./DashboardConnectedCard";
import { DashboardWaitingApprovalDocumentsList } from "./DashboardWaitingApprovalDocumentsList";

const ROUTING_DOCUMENTS_CAPTION_TOOLTIP =
  "Document submitted for approval but not signed by all approvers.";

type DashboardRoutingDocumentsCardProps = {
  documents: DashboardApprovalDocumentItem[];
  count?: number;
  orgId: string;
  actions?: ReactNode;
  selectedDeviceId?: string;
  fallbackDeviceId?: string;
  className?: string;
};

export const DashboardRoutingDocumentsCard = ({
  documents,
  count,
  orgId,
  actions,
  selectedDeviceId,
  fallbackDeviceId,
  className,
}: DashboardRoutingDocumentsCardProps) => {
  return (
    <DashboardConnectedCard
      rootTestId="dashboard-routing-documents-connected-card"
      metricTestId="dashboard-routing-documents-metric-card"
      caption="Documents currently routing"
      totalNumber={count ?? documents.length}
      metricClassName="border-cyan-200 bg-cyan-50"
      valueClassName="text-cyan-700"
      sectionLabel="Documents currently routing"
      actions={actions}
      captionTooltip={ROUTING_DOCUMENTS_CAPTION_TOOLTIP}
      className={className}
    >
      <div className="min-h-0 flex-1 overflow-y-auto pr-1">
        <DashboardWaitingApprovalDocumentsList
          documents={documents}
          isLoading={false}
          orgId={orgId}
          selectedDeviceId={selectedDeviceId}
          fallbackDeviceId={fallbackDeviceId}
        />
      </div>
    </DashboardConnectedCard>
  );
};
